
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1137","viewBox":"0 0 1137 520","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M766.367 126.44L1144-287H755.031L572-86.515 388.969-287H0l377.633 413.44L0 539.88l377.633 413.44L0 1367h388.969L572 1166.52 755.031 1367H1144L766.367 953.56 1144 540.12 766.367 126.68v-.24zM572 740.605L388.969 540.12 572 339.635 755.031 540.12 572 740.605z","fill":"#fff","fill-opacity":".3"}})])
          )
        }
      }
    